import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tab extends Component {
    static propTypes={
        children: PropTypes.element,
        label: PropTypes.string.isRequired,
        onSelect: PropTypes.func.isRequired
    }
    state = {  }
    render() {
        return (
            <React.Fragment>{this.props.children}</React.Fragment>
        )
    }
}

export default Tab